module.exports = __webpack_public_path__ + "img/prioritas_interpackmaxi_dfod_dg_k.2a4ff224.png";